'use client'

import { useCallback, useState } from 'react'
import { useSession } from 'next-auth/react'

import { NavigationOpenables } from 'shared/types/navigation'

import useCartStore from '../../../store/cartStore'

export const useTmsReservationHandlers = (
  setOpenDropdown?: (name: NavigationOpenables, value: boolean) => void
) => {
  const session = useSession()
  const { cancelTmsReservation } = useCartStore()
  const [isEditing, setIsEditing] = useState(false)

  const handleCancelReservation = useCallback(async () => {
    await cancelTmsReservation(session)
    setIsEditing(false)
  }, [cancelTmsReservation, session])

  const handleEdit = useCallback(() => {
    setIsEditing(true)
  }, [])

  const handleEndReservation = useCallback(() => {
    setIsEditing(false)
    setOpenDropdown?.('deliveryReservation', false)
  }, [setOpenDropdown])

  const handleCancelEdit = useCallback(() => {
    setIsEditing(false)
  }, [])

  return {
    isEditing,
    handlers: {
      handleCancelReservation,
      handleEdit,
      handleEndReservation,
      handleCancelEdit
    }
  }
}
